import { Badge } from "antd";
import { HTMLAttributes } from "react";
import colors from "../../constants/colors";

interface TimelineItemProps extends HTMLAttributes<HTMLLIElement> {
  title?: string;
  time: string;
  color?: string;
  details: string;
  index: number;
  length: number;
}

export default function TimelineItem({
  title,
  time,
  color = colors?.tintNeutral,
  details,
  index,
  length,
  ...rest
}: TimelineItemProps) {
  return (
    <li
      className="mb-0 last:mb-0 flex cursor-pointer hover:bg-light/20 py-3 rounded-sm px-6"
      {...rest}
    >
      <div className="w-8 relative">
        <Badge
          status={index === 0 ? "processing" : "default"}
          className="timeline-badge relative -top-[1px] z-10"
          color={color}
        />
        {length - 1 !== index && (
          <div className="absolute w-[1px] h-full border-l-2 border-extra-light border-dashed top-4 left-[5px]" />
        )}
      </div>

      <div className="flex-1 ">
        {title && (
          <h6 className="text-xs font-medium mb-[3px]" style={{ color: color }}>
            {title}
          </h6>
        )}
        <h6 className="text-xs font-semibold text-tint-neutral mb-[3px]">
          {time}
        </h6>
        <p className="text-display-body text-sm">{details}</p>
      </div>
    </li>
  );
}
